import * as Yup from "yup";

import {
  CurrencyPicker,
  InsurerPicker,
  OfficeButton,
  PDFRenderer,
  ReInsurerPicker,
  SelectInput,
  TextInput,
} from "components";
import { useEffect, useMemo } from "react";

import _ from "lodash";
import config from "config";
import { useFormik } from "formik";
import { useStatementPaidCheques } from "hooks/data/use-statement-paid-cheques";
import { wrapClick } from "utils";

type Props = {};

const SOAReportTab = (props: Props) => {
  const form = useFormik<any>({
    initialValues: {
      insurer_id: "",
      reinsurer_id: "",
      from: "",
      to: "",
    },
    onSubmit: () => {
      form.setFormikState((state) => ({ ...state, status: "SUBMIITED" }));
      form.setSubmitting(false);
      return;
    },
    validationSchema: Yup.object().shape({
      insurer_id: Yup.string().required("Insurer is required"),
      reinsurer_id: Yup.string().required("Re-Insurer is required"),
      from: Yup.date().required("From is required"),
      to: Yup.date().required("To  is required"),
    }),
    initialStatus: "NOT_SUBMIITED",
  });
  const { loadingCheques, cheques } = useStatementPaidCheques();
  const loading = loadingCheques;

  const data = useMemo(
    () =>
      btoa(
        JSON.stringify({
          insurer_id: form?.values?.insurer_id,
          reinsurer_id: form?.values?.reinsurer_id,
          from: form?.values?.from,
          to: form?.values?.to,
        })
      ),
    [
      form.values.insurer_id,
      form.values.from,
      form.values.to,
      form.values.reinsurer_id,
    ]
  );

  useEffect(() => {
    form.setFormikState((state) => ({ ...state, status: "NOT_SUBMIITED" }));
    form.setSubmitting(false);
  }, [form.values.currency, form.values.date, form.values.cheque]);

  return (
    <div className="w-full">
      <div className="py-3 flex justify-between">
        <h1 className="font-bold text-primary text-lg">SOA Report</h1>
        <div className="flex justify-end items-center gap-5">
          {form.status === "SUBMIITED" && form.isValid && (
            <a
              target="_blank"
              className="bg-teal-500 text-white px-3 py-2 rounded-md shadow-sm"
              href={`${config.asset.uri}export-soa-data-to-excel/${data}`}
            >
              Download Excel Report
            </a>
          )}
          <OfficeButton
            disabled={form.isSubmitting}
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Generating ..." : "Generate Report"}
          </OfficeButton>
        </div>
      </div>
      <form className="bg-white p-6 space-y-6">
        <div className=" grid gap-3  grid-cols-2 shadow-sm">
          <div>
            <InsurerPicker
              id="insurer_id"
              label="Insurer"
              placeholder="e.g. Afro Asian"
              rawId
              required={true}
              {...form}
            />
          </div>
          <div>
            <ReInsurerPicker
              id={"reinsurer_id"}
              rawId
              required
              placeholder="select Reisnurer"
              label={"Re-Insurer"}
              {...form}
            />
          </div>
          <div>
            <TextInput
              labelColor="text-primary-500"
              id="from"
              label="From"
              type="date"
              required={true}
              {...form}
            />
          </div>
          <div>
            <TextInput
              labelColor="text-primary-500"
              id="to"
              label="To"
              type="date"
              required={true}
              {...form}
            />
          </div>
        </div>
        {/* <OfficeButton
          disabled={form.isSubmitting}
          onClick={wrapClick(form.handleSubmit)}
        >
          {form.isSubmitting ? "Generating ..." : "Generate Report"}
        </OfficeButton> */}
      </form>
      {form.status === "SUBMIITED" && form.isValid && (
        <PDFRenderer
          url={`${config.asset.uri}soa_report/${btoa(
            JSON.stringify({
              insurer_id: form?.values?.insurer_id,
              reinsurer_id: form?.values?.reinsurer_id,
              from: form?.values?.from,
              to: form?.values?.to,
            })
          )}`}
        />
      )}
    </div>
  );
};

export default SOAReportTab;
